// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"71":"market-modal","331":"market","784":"showcase"}[chunkId] || chunkId) + "-legacy." + {"71":"e2da5682","231":"dca89297","331":"3aadb5e2","784":"db79fb33"}[chunkId] + ".js";
};